<div class="u-borderBottom-grey100" mat-dialog-title>
  <ng-container i18n="@@userOnboardingErrorDailog.title"
    >Pending Invites</ng-container
  >
</div>
<mat-dialog-content class="u-borderBottom-grey100">
  <div
    class="u-paddingTop-16 u-text-maxWidth"
    i18n="@@userOnboardingErrorDailog.description"
  >
    Please respond accept/decline to all your pending program invitations.
  </div>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <div class="u-padding-0-8" fxLayout="row" fxLayoutGap="8px">
    <button
      mat-stroked-button
      (click)="drawerRef.close()"
      type="button"
      color="primary"
      i18n="@@global.okay"
    >
      Okay
    </button>
  </div>
</mat-dialog-actions>
